import React from "react";
import { Box } from "@mui/material";

import Hero1 from "../components/Hero1";
import Hero2 from "../components/Hero2";
import Hero3 from "../components/Hero3";
import Hero4 from "../components/Hero4";

function HomePage() {
  return (
    <Box sx={{ width: "100%" }}>
      <Hero1 />
      <Hero2 />
      <Hero3 />
      <Hero4 />
    </Box>
  );
}

export default HomePage;
